export const DEFAULT_SEED = 0;
export const MAX_SEED = 0xffffffff;

export function isSeed(value: unknown): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= MAX_SEED;
}

/** Canonical decimal representation, shared by links and API category parsing. */
export function parseSeed(value: string): number | null {
  if (!/^(0|[1-9]\d{0,9})$/.test(value)) return null;
  const seed = Number(value);
  return isSeed(seed) ? seed : null;
}
